import './ProductCategoryFilter.scss'

import Dropdown from 'lib/components/Dropdown/Dropdown'
import { buildQueryString, QUERY_KEYS, QUERY_VALUES } from 'lib/util/routing'
import ProductCategory, { getDisplayNameByCategory } from 'pages/Home/ProductCategory'
import Section from 'pages/Home/Section'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import ProductDropdownTrigger from './ProductDropdownTrigger'

export interface ProductCategoryFilterProps extends RouteComponentProps {
  currentProductCategory: ProductCategory
  selectedSection: Section
}

export default withRouter(function ProductCategoryFilter(props: ProductCategoryFilterProps) {
  const { currentProductCategory, location, selectedSection } = props
  const [t] = useTranslation()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const openDropdown = () => setIsDropdownOpen(true)
  const closeDropdown = () => setIsDropdownOpen(false)
  const displayNameByCategory = getDisplayNameByCategory(t)
  const renderMoreOption = selectedSection !== Section.Videos

  function saveInLocalStorage(productCategory: string) {
    localStorage.setItem(QUERY_KEYS.category, productCategory)
  }

  return (
    <div className="product-category-filter">
      {t('home.productCategoryFilter.message')}
      <Dropdown>
        <ProductDropdownTrigger onClick={openDropdown} currentProductCategory={currentProductCategory} />
        {isDropdownOpen && (
          <Dropdown.Menu onRequestClose={closeDropdown} offset="1, -2">
            <Dropdown.MenuItem
              onClick={() => saveInLocalStorage(QUERY_VALUES.rise)}
              linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.category, QUERY_VALUES.rise]]) } }}
              key="rise">
              {displayNameByCategory[ProductCategory.Rise]}
            </Dropdown.MenuItem>
            <Dropdown.MenuItem
              onClick={() => saveInLocalStorage(QUERY_VALUES.storyline)}
              linkProps={{
                to: { search: buildQueryString(location, [[QUERY_KEYS.category, QUERY_VALUES.storyline]]) }
              }}
              key="storyline">
              {displayNameByCategory[ProductCategory.Storyline]}
            </Dropdown.MenuItem>
            {renderMoreOption && (
              <Dropdown.MenuItem
                onClick={() => saveInLocalStorage(QUERY_VALUES.more)}
                linkProps={{ to: { search: buildQueryString(location, [[QUERY_KEYS.category, QUERY_VALUES.more]]) } }}
                key="more">
                {displayNameByCategory[ProductCategory.More]}
              </Dropdown.MenuItem>
            )}
          </Dropdown.Menu>
        )}
      </Dropdown>
    </div>
  )
})
